import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { HelmetProvider } from "react-helmet-async";
import { SmoothScroll } from "@/components/SmoothScroll";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <SmoothScroll>
          <App />
        </SmoothScroll>
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

// Hydrate when the markup was prerendered (react-snap), otherwise render fresh.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
